import { render, staticRenderFns } from "./EditorPrice.vue?vue&type=template&id=043e08ae&scoped=true"
import script from "./EditorPrice.vue?vue&type=script&lang=js"
export * from "./EditorPrice.vue?vue&type=script&lang=js"
import style0 from "./EditorPrice.vue?vue&type=style&index=0&id=043e08ae&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043e08ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('043e08ae')) {
      api.createRecord('043e08ae', component.options)
    } else {
      api.reload('043e08ae', component.options)
    }
    module.hot.accept("./EditorPrice.vue?vue&type=template&id=043e08ae&scoped=true", function () {
      api.rerender('043e08ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/fallsFlowManageConfig/fallsFlowManage/components/EditorPrice.vue"
export default component.exports